import {fontSize, colorPalette, fontWeight} from '../../../config';
import {btnProps} from '../../../util';

const firstTextProps = {
	inputsText: {
		fontSize: {
			desktop: fontSize.lg,
		},
		fontWeight: fontWeight.medium,
	},
	input: {
		fontSize: {desktop: fontSize.lg},
		height: '60px',
		// color: colorPalette.white,
	},
	description: {
		fontSize: {
			desktop: fontSize.lg,
		},
		color: colorPalette.white,
		fontWeight: fontWeight.medium,
	},
};

export const firstProps = {
	inputs: [
		{
			type: 'input',
			text: {...firstTextProps.inputsText, children: '제목'},
			input: {
				name: 'title',
				placeholder: '제목을 입력해주세요.',
				borderRadius: '0.75rem',
				...firstTextProps.input,
			},
		},
		{
			type: 'input',
			text: {...firstTextProps.inputsText, children: '이름'},
			input: {
				name: 'author',
				placeholder: '이름을 입력해주세요.',
				borderRadius: '0.75rem',
				...firstTextProps.input,
			},
		},
		{
			type: 'input',
			text: {...firstTextProps.inputsText, children: '비밀번호'},
			input: {
				name: 'password',
				placeholder:
					'비밀번호 설정 시 글은 비밀번호 입력 후 확인이 가능합니다.',
				borderRadius: '0.75rem',
				...firstTextProps.input,
			},
		},
		{
			type: 'input',
			text: {...firstTextProps.inputsText, children: '내용'},
			textarea: {
				name: 'content',
				borderRadius: '0.75rem',
				fontSize: {desktop: fontSize.lg},
			},
		},
	],
	listBtn: {
		text: {
			...firstTextProps.realBlack,
			color: colorPalette.neonbtn,
			children: '목록',
		},
		bgColor: colorPalette.white,
		isRounded: true,
		border: `1px solid ${colorPalette.placeholder}`,
		// border: `1px solid ${colorPalette.border}`,
		onClick: () => window.history.back(),
	},
	writeBtn: {
		text: {
			...firstTextProps.description,
			children: '완료',
			color: colorPalette.white,
		},
		bgColor: colorPalette.neonbtn,
		isRounded: true,
	},
	fileInput: {
		alignItems: 'center',
		text: {
			...firstTextProps.inputsText,
			children: '첨부파일',
		},
		file: {
			text: {
				...firstTextProps.description,
				children: '파일선택',
			},
			onChange: (e) => console.log(e),
		},
	},
	description: {
		...firstTextProps.description,
		children:
			'첨부파일 제한 용량은 총 2MB이하입니다. (이미지 사이즈 600*800이하) 용량 초과 파일은 DB에 저장하지 않습니다.',
	},
};

export const initialState = {
	author: '',
	password: '',
	title: '',
	content: '',
};

export const initialRefundState = {
	author: '',
	password: '',
	title: '',
	content: `[입금 정보]
- 입금자명 :
** 단체로 입금했을 경우 단체명을 작성해 주십시오.

[환불 정보]
- 환불자명 :
- 생년월일 :
- 연락처 :
- 환불 은행명 :
- 환불 계좌번호 :
- 환불 예금주 :
- 환불 요청 금액 :
** 환불은 10% 수수료 제하고 입금됩니다. 자세한 사항은 유의사항>환불규정 참고

- 추가 요청사항 :`,
};
